import React, { useState, useEffect, lazy, Suspense } from 'react';
import { HeadersCentral } from "../../layouts/headers-central/headers-central";
import { MainContent } from "../../layouts/MainContent";
import { Headers } from "../../layouts/headers/headers";
import { SubscriptionList } from "../../components/datatable/SubcriptionList";
import { getAllSubcriptionPlain } from "../../interpreter/subcription";
import { FaPlus } from "react-icons/fa"; // ✅ Ícono más ligero
// ✅ Lazy load de modales
const AggSubcription = lazy(() => import("../../components/modals/aggSubcription"));
const DetailsSubcriptions = lazy(() => import("../../components/modals/detailsSubcription"));
const LowSubcription = lazy(() => import("../../components/modals/lowSubcription"));
const UserModal = lazy(() => import("../../components/modals/profileUser"));

const Suscription = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const [activeModal, setActiveModal] = useState(null);

    const fetchSubscriptions = async () => {
        try {
            const data = await getAllSubcriptionPlain();
            setSubscriptions(data);
        } catch (error) {
            console.error("Error al obtener suscripciones:", error);
            setSubscriptions([]);
        }
    };

    useEffect(() => {
        fetchSubscriptions();
    }, []);

    const openModal = (modalType, suscripciones) => {
        setActiveModal(modalType);
        setSelectedSubscription(suscripciones);
    };

    const closeModal = () => {
        setActiveModal(null);
        setSelectedSubscription(null);
    };

    const handleAddSuscription = (newSuscripcion) => {
        setSubscriptions(prev => [...prev, { id: prev.length + 1, ...newSuscripcion }]);
        closeModal();
    };

    const handleCancelSuccess = (updatedSubcription) => {
        setSubscriptions(prev =>
            prev.map(sub => sub.id === updatedSubcription.id ? updatedSubcription : sub)
        );
        closeModal();
    };

    return (
        <div className="flex h-screen">
            {/* Sidebar */}
            <Headers />

            {/* Contenido Principal */}
            <MainContent>
                <HeadersCentral
                    showDropdown={showDropdown}
                    setShowDropdown={setShowDropdown}
                    openModal={() => openModal('user')}
                />

                <main className="p-6 w-full">
                    <h1 className="text-2xl font-bold mb-7">Panel de Control de Suscripciones</h1>
                    <div className="mb-4">
                        <button
                            className="bg-purple-600 hover:bg-purple-400 text-white font-semibold py-2 px-4 rounded-lg shadow-md flex items-center gap-2 w-auto"
                            onClick={() => openModal('add')}
                        >
                            <FaPlus size={16} /> Agregar Suscripción
                        </button>
                    </div>

                    {/* DataTable de Suscripciones */}
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <Suspense fallback={null}>
                            {activeModal === 'user' && <UserModal isOpen={true} onClose={closeModal} />}
                        </Suspense>

                        <SubscriptionList
                            openModal={openModal}
                            subscriptions={subscriptions}
                            setSubscriptions={setSubscriptions}
                        />
                    </div>
                </main>
            </MainContent>

            {/* Modales */}
            <Suspense fallback={null}>
                {activeModal === 'add' && (
                    <AggSubcription
                        isOpen={true}
                        onClose={closeModal}
                        addSuscripcion={handleAddSuscription}
                    />
                )}
                {activeModal === 'detail' && (
                    <DetailsSubcriptions
                        isOpen={true}
                        onClose={closeModal}
                        subcriptionId={selectedSubscription}
                    />
                )}
                {activeModal === 'annular' && (
                    <LowSubcription
                        isOpen={true}
                        onClose={closeModal}
                        subcriptionId={selectedSubscription}
                        onCancelSuccess={handleCancelSuccess}
                    />
                )}
            </Suspense>
        </div>
    );
};

export default Suscription;
